import React from "react";

const Section = ({ s, i }) => (
  <section data-testid={`legal-section-${i}`} className="space-y-3">
    <h2 className="font-serif text-2xl text-ink">{s.h}</h2>
    {(s.p || []).map((t) => <p key={t}>{t}</p>)}
    {s.list && <ul className="list-disc pl-5 space-y-2">{s.list.map((t) => <li key={t}>{t}</li>)}</ul>}
    {(s.after || []).map((t) => <p key={t}>{t}</p>)}
  </section>
);

export const LegalPage = ({ testId, eyebrow, title, updated, sections, children }) => (
  <div data-testid={testId} className="container-ccc py-16 max-w-3xl">
    <div className="eyebrow">{eyebrow}</div>
    <h1 className="font-serif text-4xl sm:text-5xl mt-3">{title}</h1>
    <p data-testid="legal-updated" className="mt-3 text-xs uppercase tracking-[0.16em] text-ink-muted">Last updated {updated}</p>
    <div className="mt-10 space-y-10 text-ink-muted leading-relaxed">
      {sections.map((s, i) => <Section key={s.h} s={s} i={i} />)}
      {children}
    </div>
  </div>
);
